import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import _ from 'lodash';
import { Observable } from 'rxjs';
import {
  ModalOpenerService,
  UserService,
  EnterpriseSearchService,
  ServiceType
} from '@sabstravtech/obtservices/angular';
import { TranslateService } from '@ngx-translate/core';
import {
  EurostarEnterpriseSearchInterface,
  EurostarTempParams,
  EurostarResults,
  SortTypesEurostar,
  FlightEnterpriseSearchInterface,
  LocationTypes
} from '@sabstravtech/obtservices/base';
import { Router } from '@angular/router';

import { LightningModalTypes } from '../../../core/classes/modal-types.enum';
import { BaseResultsComponent } from '../../../core/components/base_components/base-results.component';
import { SortType } from '../../interfaces/sort-type.interface';
import { DeviceDetector } from '../../../core/services/device-detector.service';
import { ThemeService } from '../../../core/services/theme.service';

@Component({
  selector: 'app-eurostar',
  templateUrl: './eurostar.component.html',
  styleUrls: ['./eurostar.component.scss'],
  standalone: false
})
export class EurostarComponent extends BaseResultsComponent implements OnInit {
  searchType: ServiceType = ServiceType.Eurostar;
  ServiceType: typeof ServiceType = ServiceType;
  searchResults: any = {
    outbound: [],
    inbound: []
  };
  $margin: Observable<number> = new Observable();
  showClasses: any;
  public searchParams: EurostarEnterpriseSearchInterface;
  public sortOption: SortTypesEurostar = SortTypesEurostar.CheapestFirst;
  public search: EurostarTempParams;
  public results: EurostarResults[] = [{ outbound: [], inbound: [] }];
  public SortTypesEurostar: typeof SortTypesEurostar = SortTypesEurostar;
  public flightSearchParams: FlightEnterpriseSearchInterface;
  public destination: string;

  constructor(
    public searchService: EnterpriseSearchService,
    public deviceDetector: DeviceDetector,
    public modalService: ModalOpenerService,
    titleService: Title,
    translateService: TranslateService,
    router: Router,
    themeService: ThemeService,
    userService: UserService
  ) {
    super(titleService, translateService, themeService, searchService, userService, router);
    this.searchParams = searchService.searches[ServiceType.Eurostar];
    this.flightSearchParams = searchService.searches[ServiceType.Flight];
  }

  ngOnInit(): void {
    this.setResultsTitle('Eurostar results');
    this.search = this.searchService.searches[ServiceType.Eurostar].originalUserSearch;

    this.subscribe(this.searchParams.results, (results: EurostarResults[]) => {
      if (results.length) {
        this.results = results;
        this.destination =
          this.searchParams.rawResults.journeys[0].outboundFlights[0].destinationAirportDetail.countryCode;
        this.setShowClasses();
      } else {
        this.destination = null;
        this.results = [{ outbound: [], inbound: [] }];
        this.setShowClasses();
      }
      console.log(this.showClasses);
    });
  }

  openFareRules(): void {
    this.modalService.open(LightningModalTypes.ModalFareRulesComponent, {
      windowClass: 'fare-rules-modal',
      centered: true
    });
  }

  openFareRulesAndFocus(): void {
    this.openFareRules();
    document.getElementById('standardHeader').focus();
  }

  onSortingSelected(sortType: SortType): void {
    try {
      this.searchResults = this.searchParams.sortResults(sortType.code, sortType.dir);
    } catch (e) {
      console.error(
        `Sorting function ${sortType} does not exists in Eurostar model, results will not be sorted.`,
        e
      );
    }
  }

  setShowClasses(): void {
    if (this.results[0].inbound.length === 0 && this.results[0].outbound.length === 0) {
      this.showClasses = {
        standard: true,
        standardPremier: true,
        businessPremier: true
      };
    } else {
      const classes: any = {
        standard: false,
        standardPremier: false,
        businessPremier: false
      };
      _.each(['inbound', 'outbound'], (dir) => {
        this.results[0][dir] = this.results[0][dir].filter((result) => {
          return (
            (!result.standardFare.isDisabled && Object.keys(result.standardFare.fare).length > 0) ||
            (!result.standardPremierFare.isDisabled &&
              Object.keys(result.standardPremierFare.fare).length > 0) ||
            (!result.businessPremierFare.isDisabled &&
              Object.keys(result.businessPremierFare.fare).length > 0)
          );
        });
        _.each(this.results[0][dir], (result) => {
          if (!result.standardFare.isDisabled) {
            classes.standard = true;
          }
          if (!result.standardPremierFare.isDisabled) {
            classes.standardPremier = true;
          }
          if (!result.businessPremierFare.isDisabled) {
            classes.businessPremier = true;
          }
        });
      });
      this.showClasses = classes;
      console.log('classes: ', this.showClasses);
    }
  }

  skipToResultContent(): boolean {
    return super.skipToResultContent('eurostar');
  }
  /**
   * Do another search - based off of the input at the top of the screen
   */
  reSearch(): void {
    this.performReSearch(ServiceType.Eurostar, () => {
      this.search = this.searchService.searches[ServiceType.Eurostar].originalUserSearch;
    });
  }

  switchToHotel(): void {
    // Set country for hotel search if available
    const arriveLocation = this.searchParams.arriveLocation;
    if (arriveLocation && typeof arriveLocation === 'object' && arriveLocation.countryCode) {
      this.searchService.searches[ServiceType.Hotel].country = {
        cCode: arriveLocation.countryCode,
        cName: arriveLocation.countryCode
      };
    }

    // Navigate to hotel search with eurostar destination
    this.navigateToHotelSearch(
      ServiceType.Eurostar,
      {
        checkin: this.searchParams.outBoundDate,
        checkout: this.searchParams.inboundDate
      },
      arriveLocation && typeof arriveLocation === 'object'
        ? {
            name: arriveLocation.destination || arriveLocation.gateway,
            countryCode: arriveLocation.countryCode,
            latitude: arriveLocation.latitude,
            longitude: arriveLocation.longitude,
            type: LocationTypes.City
          }
        : undefined
    );
  }
}
